import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import WishList from '../Components/WishList'
import { translate } from '../Services/translation';
import { changeQuantity, updateWishList, add } from '../Actions/WishList.action'
 
class WishListContainer extends Component {
    constructor(props) {
        super(props);
    }
 
    render() {
        const { wishlist } = this.props;
        if (!wishlist || !wishlist.items || wishlist.items.length < 1) {
            return (
                <div className="row">
                    <div className="small-12">
                        <h1 className="checkout__title column">{translate('wishlist.empty')}</h1>
                    </div>
                </div>
            );
        }
 
        const { payload } = wishlist;
        return (
            <Fragment>
                {
                    payload && (<div>{payload.message}</div>)
                }
                <div className="row"><div className="small-12"><h1 className="checkout__title column">Favoriter</h1></div></div>
 
                <WishList wishList={wishlist} onRemove={(articleNumber, quantity) => this.props.remove(articleNumber, quantity)} />
            </Fragment>
        )
    }
}
 
const mapStateToProps = state => {
    return {
        wishlist: state.wishlist,
    }
}
 
const mapDispatchToProps = dispatch => {
    return {
        remove: (articleNumber, quantity) => dispatch(add({articleNumber, quantity})),
        update: () => dispatch(updateWishList()),
        addToCart: () => dispatch(addToCart())
    }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(WishListContainer)